import React from 'react';
import { Users, FileText, CheckCircle, DollarSign, ArrowUpRight, Plus, Clock } from 'lucide-react';
import { Button } from '../components/ui/Button';
interface DashboardProps {
  onNavigate: (page: string) => void;
}
export function Dashboard({
  onNavigate
}: DashboardProps) {
  const stats = [{
    name: 'Total Applications',
    value: '1,234',
    change: '+12%',
    icon: FileText,
    color: 'bg-blue-500'
  }, {
    name: 'Active Products',
    value: '12',
    change: '+2',
    icon: CheckCircle,
    color: 'bg-green-500'
  }, {
    name: 'Pending Approvals',
    value: '45',
    change: '-5%',
    icon: Clock,
    color: 'bg-yellow-500'
  }, {
    name: 'Disbursed This Month',
    value: 'PKR 2.5M',
    change: '+18%',
    icon: DollarSign,
    color: 'bg-purple-500'
  }];
  const recentActivity = [{
    id: 1,
    user: 'Sarah Wilson',
    action: 'Created new application',
    target: 'APP-2023-001',
    time: '2 hours ago'
  }, {
    id: 2,
    user: 'Mike Johnson',
    action: 'Approved loan disbursement',
    target: 'LN-8832',
    time: '4 hours ago'
  }, {
    id: 3,
    user: 'System',
    action: 'Generated monthly reports',
    target: 'October 2023',
    time: '5 hours ago'
  }, {
    id: 4,
    user: 'Admin User',
    action: 'Updated fee structure',
    target: 'Personal Loan Standard',
    time: '1 day ago'
  }];
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-2016">
      {/* Welcome Section */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2017">
        <div data-id="element-2018">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-2019">
            Welcome back, Admin
          </h2>
          <p className="text-gray-500 mt-1" data-id="element-2020">
            Here's what's happening with your loan portfolio today.
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-2021">
          <Button variant="secondary" onClick={() => onNavigate('applications')} data-id="element-2022">
            <FileText className="mr-2 h-4 w-4" data-id="element-2023" />
            View Applications
          </Button>
          <Button onClick={() => onNavigate('loan-products')} data-id="element-2024">
            <Plus className="mr-2 h-4 w-4" data-id="element-2025" />
            Create Product
          </Button>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2026">
        {stats.map(stat => <div key={stat.name} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-2027">
            <div className="flex items-center justify-between" data-id="element-2028">
              <div data-id="element-2029">
                <p className="text-sm font-medium text-gray-500" data-id="element-2030">{stat.name}</p>
                <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-2031">
                  {stat.value}
                </p>
              </div>
              <div className={`p-3 rounded-full ${stat.color} bg-opacity-10`} data-id="element-2032">
                <stat.icon className={`h-6 w-6 ${stat.color.replace('bg-', 'text-')}`} data-id="element-2033" />
              </div>
            </div>
            <div className="mt-4 flex items-center text-sm" data-id="element-2034">
              <ArrowUpRight className="h-4 w-4 text-green-500 mr-1" data-id="element-2035" />
              <span className="text-green-600 font-medium" data-id="element-2036">{stat.change}</span>
              <span className="text-gray-400 ml-2" data-id="element-2037">from last month</span>
            </div>
          </div>)}
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-2038">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between" data-id="element-2039">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-2040">
            Recent Activity
          </h3>
          <Button variant="ghost" size="sm" data-id="element-2041">
            View All
          </Button>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-2042">
          {recentActivity.map(activity => <div key={activity.id} className="px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-2043">
              <div className="flex items-center space-x-4" data-id="element-2044">
                <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-2045">
                  <span className="text-sm font-medium text-gray-600" data-id="element-2046">
                    {activity.user.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div data-id="element-2047">
                  <p className="text-sm font-medium text-gray-900" data-id="element-2048">
                    {activity.user}{' '}
                    <span className="font-normal text-gray-500" data-id="element-2049">
                      {activity.action}
                    </span>
                  </p>
                  <p className="text-xs text-blue-600 font-medium mt-0.5" data-id="element-2050">
                    {activity.target}
                  </p>
                </div>
              </div>
              <span className="text-xs text-gray-400" data-id="element-2051">{activity.time}</span>
            </div>)}
        </div>
      </div>
    </div>;
}